/* eslint-disable */

export function yearToCropYearFull(year?: string | number) {
  if (!year) {
    return "";
  }
  const numberYear = Number(year);
  const nextYear = numberYear+1;
  return `${numberYear}/${nextYear}`;
}

export function yearToCropYearShort(year?: string | number) {
  if (!year) {
    return "";
  }
  const numberYear = Number(year);
  const nextYear = (numberYear+1).toString().substr(2, 2);
  return `${numberYear}/${nextYear}`;
}

export function yearShortToCropYearShort(year?: string | number) {
  if (!year) {
    return "";
  }
  const numberYear = Number(year);
  const nextYear = (numberYear+1);
  return `${numberYear.toString().substr(2, 2)}/${nextYear.toString().substr(2, 2)}`;
}